import { render, staticRenderFns } from "./SurveyRevision.vue?vue&type=template&id=85567d88&"
import script from "./SurveyRevision.vue?vue&type=script&lang=js&"
export * from "./SurveyRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports